import React from "react";
import Doodles from "assets/images/Doodles.png";

interface Iprops {
  text?: string;
}

export default function Empty({ text }: Iprops) {
  return (
    <div className="relative flex flex-col justify-center items-center h-[calc(100vh-400px)] my-6">
      <img src={Doodles} alt="doodle" />
      {text && <p className="mt-2 text-center text-xl">{text}</p>}
    </div>
  );
}
